import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginPage from "../components/LoginPage/LoginPage";

export default function LoginPageRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  return <LoginPage navigate={navigate} location={location} />;
}
